// Subgrupos do De/Para: predefinidos e agrupamento para exibição na hierarquia.

// Mesmos nomes que o backend usa na pré-vinculação (WfClassificacaoContaGrupo.SubgrupoDepreciacao/Amortizacao).
export const SUBGRUPOS_PREDEFINIDOS = ['Depreciação', 'Amortização'] as const;

/** Predefinidos + subgrupos já usados na empresa, sem duplicatas e em ordem alfabética. */
export const opcoesDeSubgrupo = (existentes: (string | null | undefined)[]): string[] =>
  Array.from(new Set([...SUBGRUPOS_PREDEFINIDOS, ...existentes.filter((s): s is string => !!s)]))
    .sort((a, b) => a.localeCompare(b, 'pt-BR'));

export interface SubgrupoComContas<T> {
  subgrupo: string | null; // null = contas do grupo sem subgrupo
  itens: T[];
}

/** Agrupa as contas de um grupo por subgrupo: nomeados em ordem alfabética, "sem subgrupo" por último. */
export const agruparPorSubgrupo = <T extends { subgrupoNome: string | null }>(itens: T[]): SubgrupoComContas<T>[] => {
  const mapa = new Map<string | null, T[]>();
  itens.forEach(i => {
    const chave = i.subgrupoNome || null;
    mapa.set(chave, [...(mapa.get(chave) ?? []), i]);
  });
  return Array.from(mapa.entries())
    .map(([subgrupo, lista]) => ({ subgrupo, itens: lista }))
    .sort((a, b) => {
      if (a.subgrupo === null) return 1;
      if (b.subgrupo === null) return -1;
      return a.subgrupo.localeCompare(b.subgrupo, 'pt-BR');
    });
};
